import { MenuItemLink } from 'react-admin';

import { withStyles } from '@material-ui/core/styles';

const StyledMenuItemLink = withStyles((theme) => ({
  root: {
    color: theme.palette.primary.main,
    '&:hover': {},
    marginLeft: '7px',
  },
  active: {
    borderLeft: '5px solid red',
    borderColor: '#00897B',
    backgroundColor: 'rgba(0, 138, 124, 0.15)',
    marginLeft: '2px',
  },
}))(MenuItemLink);

export default StyledMenuItemLink;
